import {Plain} from '../../../../../shared/model/plain.type.model';
import {ElementPage} from './element.page.model';

/**
 * Réhydrate un élément venu d'une source externe, et laisse passer celui qui en est déjà un.
 *
 * Une page se reconstruit à chaque retouche du brouillon — changer un libellé fabrique une nouvelle
 * `FormPage` à partir de l'ancienne. Recopier alors ses éléments un à un les remplacerait tous par
 * des objets neufs, alors qu'un seul a changé : l'éditeur ne pourrait plus reconnaître ses cartes
 * d'une version du brouillon à la suivante, et les referait toutes à chaque caractère saisi.
 */
export const toElementPage = (element: Plain<ElementPage> | ElementPage): ElementPage =>
    element instanceof ElementPage ? element : new ElementPage(element);
